import React from 'react';
import { TacticalLabel } from './TacticalLabel';
import { MapPin } from 'lucide-react';
const cities = ['Phoenix', 'Scottsdale', 'Mesa', 'Gilbert', 'Chandler', 'Tempe', 'Glendale', 'Peoria', 'Surprise', 'Goodyear', 'Avondale', 'Buckeye', 'Queen Creek', 'San Tan Valley', 'Maricopa', 'Casa Grande', 'Paradise Valley', 'Fountain Hills', 'Cave Creek', 'Carefree', 'Apache Junction', 'Sun City', 'Sun City West', 'Litchfield Park', 'El Mirage', 'Tolleson', 'Florence', 'Wickenburg', 'Guadalupe'];
export function ServiceAreas() {
  return <section id="areas" className="py-24 bg-[#141A15] relative overflow-hidden" data-id="element-315">
      {/* Stylized Map Background */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-316">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-317">
          <defs data-id="element-318">
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-319">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#7A8174" strokeWidth="0.5" data-id="element-320" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" data-id="element-321" />
          {/* Abstract Topo Lines for Map Feel */}
          <path d="M-100,200 Q300,400 800,100 T1600,300" fill="none" stroke="#7A8174" strokeWidth="2" data-id="element-322" />
          <path d="M-100,250 Q300,450 800,150 T1600,350" fill="none" stroke="#7A8174" strokeWidth="1" data-id="element-323" />
          <path d="M-100,300 Q300,500 800,200 T1600,400" fill="none" stroke="#7A8174" strokeWidth="0.5" data-id="element-324" />
        </svg>
      </div>

      <div className="container mx-auto px-4 sm:px-6 relative z-10" data-id="element-325">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-326">
          <div className="flex justify-center mb-4" data-id="element-327">
            <MapPin className="w-8 h-8 text-sapper-red animate-pulse" data-id="element-328" />
          </div>
          <h2 className="font-condensed font-bold text-5xl sm:text-6xl text-sapper-white uppercase tracking-tight mb-4" data-id="element-329">
            FIELD OPERATIONS. PHOENIX METRO
          </h2>
          <p className="font-sans text-lg text-sapper-gray" data-id="element-330">
            From Wickenburg to Florence. We deploy across the entire Valley.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3" data-id="element-331">
          {cities.map(city => <a key={city} href={`#${city.toLowerCase().replace(/\s+/g, '-')}`} className="bg-sapper-olive/20 border border-sapper-olive/30 rounded-full py-3 px-6 text-center font-sans text-sm text-sapper-white hover:bg-sapper-red hover:border-sapper-red transition-colors group" data-id="element-332">
              <span className="group-hover:font-bold" data-id="element-333">{city}</span>
            </a>)}
        </div>
      </div>
    </section>;
}